/* eslint-disable */
// Generated by design-tokens/generate.js — do not edit. Regenerate with `npm run tokens:generate`.

// Raw resolved values. Colours keep light and dark so dark mode can be
// enabled later without re-plumbing consumers.
export const designTokenValues = {
  '-ds-bg-default': { light: '#ffffff', dark: '#1a1a1a' },
  '-ds-bg-container-brand': { light: '#0c6776', dark: '#6dc8d7' },
  '-ds-bg-container-default': { light: '#ffffff', dark: '#1a1a1a' },
  '-ds-bg-container-secondary': { light: '#f2f2f2', dark: '#282828' },
  '-ds-bg-container-tertiary': { light: '#e1e1e1', dark: '#343434' },
  '-ds-bg-container-inverse': { light: '#212121', dark: '#e4e4e4' },
  '-ds-bg-container-strong': { light: '#fec077', dark: '#fec077' },
  '-ds-bg-container-skeleton': { light: '#f2f2f2', dark: '#282828' },
  '-ds-border-default': { light: '#e1e1e1', dark: '#343434' },
  '-ds-border-strong': { light: '#212121', dark: '#e4e4e4' },
  '-ds-border-inverse': { light: '#f8f8f8', dark: '#212121' },
  '-ds-border-disabled': { light: '#f8f8f8', dark: '#212121' },
  '-ds-border-focus': { light: '#0c6776', dark: '#6dc8d7' },
  '-ds-divider-default': { light: '#e1e1e1', dark: '#343434' },
  '-ds-bg-interactive-default': { light: '#0c6776', dark: '#6dc8d7' },
  '-ds-bg-interactive-disabled': { light: '#f8f8f8', dark: '#212121' },
  '-ds-bg-interactive-secondary': { light: '#fec077', dark: '#fec077' },
  '-ds-bg-interactive-pressed': {
    light: 'rgba(0, 0, 0, 0.1)',
    dark: 'rgba(255, 255, 255, 0.1)',
  },
  '-ds-border-interactive-default': { light: '#0c6776', dark: '#6dc8d7' },
  '-ds-border-interactive-light': { light: '#f2f2f2', dark: '#282828' },
  '-ds-bg-container-error': { light: '#ab000d', dark: '#fa9e9e' },
  '-ds-bg-container-warning': { light: '#a12001', dark: '#ffbc97' },
  '-ds-bg-container-success': { light: '#0a4e45', dark: '#91c4bd' },
  '-ds-bg-container-info': { light: '#3e4a7c', dark: '#b1b9e3' },
  '-ds-bg-container-promo': { light: '#ffbc97', dark: '#ffbc97' },
  '-ds-bg-container-error-subtle': { light: '#fcf5f6', dark: '#591313' },
  '-ds-bg-container-warning-subtle': { light: '#fcf6f5', dark: '#45321e' },
  '-ds-bg-container-success-subtle': { light: '#f5f8f8', dark: '#0e3c36' },
  '-ds-bg-container-info-subtle': { light: '#f7f8fa', dark: '#30323b' },
  '-ds-bg-container-promo-subtle': { light: '#fcf6f5', dark: '#45321e' },
  '-ds-border-error': { light: '#ab000d', dark: '#fa9e9e' },
  '-ds-border-warning': { light: '#a12001', dark: '#ffbc97' },
  '-ds-border-success': { light: '#0a4e45', dark: '#91c4bd' },
  '-ds-border-info': { light: '#3e4a7c', dark: '#b1b9e3' },
  '-ds-text-brand': { light: '#0c6776', dark: '#6dc8d7' },
  '-ds-text-primary': { light: '#212121', dark: '#e4e4e4' },
  '-ds-text-secondary': { light: '#424242', dark: '#c4c4c4' },
  '-ds-text-tertiary': { light: '#767676', dark: '#9e9e9e' },
  '-ds-text-inverse': { light: '#f8f8f8', dark: '#212121' },
  '-ds-text-light': { light: '#f8f8f8', dark: '#e4e4e4' },
  '-ds-text-dark': { light: '#212121', dark: '#212121' },
  '-ds-text-disabled': { light: '#979797', dark: '#6b6b6b' },
  '-ds-text-error': { light: '#ab000d', dark: '#fa9e9e' },
  '-ds-text-warning': { light: '#a12001', dark: '#ffbc97' },
  '-ds-text-success': { light: '#0a4e45', dark: '#91c4bd' },
  '-ds-text-info': { light: '#3e4a7c', dark: '#b1b9e3' },
  '-ds-text-error-subtle': { light: '#fcf5f6', dark: '#591313' },
  '-ds-text-warning-subtle': { light: '#fcf6f5', dark: '#45321e' },
  '-ds-text-success-subtle': { light: '#f5f8f8', dark: '#0e3c36' },
  '-ds-text-info-subtle': { light: '#f7f8fa', dark: '#30323b' },
  '-ds-icon-brand': { light: '#0c6776', dark: '#6dc8d7' },
  '-ds-icon-primary': { light: '#212121', dark: '#e4e4e4' },
  '-ds-icon-secondary': { light: '#424242', dark: '#c4c4c4' },
  '-ds-icon-tertiary': { light: '#767676', dark: '#9e9e9e' },
  '-ds-icon-inverse': { light: '#f8f8f8', dark: '#212121' },
  '-ds-icon-light': { light: '#f8f8f8', dark: '#e4e4e4' },
  '-ds-icon-dark': { light: '#212121', dark: '#212121' },
  '-ds-icon-wishlist': { light: '#fa9e9e', dark: '#fa9e9e' },
  '-ds-icon-disabled': { light: '#979797', dark: '#6b6b6b' },
  '-ds-icon-error': { light: '#ab000d', dark: '#fa9e9e' },
  '-ds-icon-warning': { light: '#a12001', dark: '#ffbc97' },
  '-ds-icon-success': { light: '#0a4e45', dark: '#91c4bd' },
  '-ds-icon-info': { light: '#3e4a7c', dark: '#b1b9e3' },
  '-ds-facebook': { light: '#1877f2', dark: '#1877f2' },
  '-ds-black-a3': 'rgba(0, 0, 0, 0.03)',
  '-ds-black-a5': 'rgba(0, 0, 0, 0.05)',
  '-ds-black-a7': 'rgba(0, 0, 0, 0.07)',
  '-ds-black-a10': 'rgba(0, 0, 0, 0.1)',
  '-ds-black-a15': 'rgba(0, 0, 0, 0.15)',
  '-ds-black-a20': 'rgba(0, 0, 0, 0.2)',
  '-ds-black-a25': 'rgba(0, 0, 0, 0.25)',
  '-ds-black-a30': 'rgba(0, 0, 0, 0.3)',
  '-ds-black-a40': 'rgba(0, 0, 0, 0.4)',
  '-ds-black-a50': 'rgba(0, 0, 0, 0.5)',
  '-ds-black-a60': 'rgba(0, 0, 0, 0.6)',
  '-ds-black-a80': 'rgba(0, 0, 0, 0.8)',
  '-ds-white-a3': 'rgba(255, 255, 255, 0.03)',
  '-ds-white-a5': 'rgba(255, 255, 255, 0.05)',
  '-ds-white-a7': 'rgba(255, 255, 255, 0.07)',
  '-ds-white-a10': 'rgba(255, 255, 255, 0.1)',
  '-ds-white-a15': 'rgba(255, 255, 255, 0.15)',
  '-ds-white-a20': 'rgba(255, 255, 255, 0.2)',
  '-ds-white-a25': 'rgba(255, 255, 255, 0.25)',
  '-ds-white-a30': 'rgba(255, 255, 255, 0.3)',
  '-ds-white-a40': 'rgba(255, 255, 255, 0.4)',
  '-ds-white-a50': 'rgba(255, 255, 255, 0.5)',
  '-ds-white-a60': 'rgba(255, 255, 255, 0.6)',
  '-ds-white-a80': 'rgba(255, 255, 255, 0.8)',
  '-ds-space-01': '4px',
  '-ds-space-02': '8px',
  '-ds-space-03': '12px',
  '-ds-space-04': '16px',
  '-ds-space-05': '24px',
  '-ds-space-06': '32px',
  '-ds-space-07': '40px',
  '-ds-space-08': '56px',
  '-ds-space-09': '64px',
  '-ds-space-10': '80px',
  '-ds-radius-none': '0px',
  '-ds-radius-xs': '2px',
  '-ds-radius-sm': '4px',
  '-ds-radius-md': '8px',
  '-ds-radius-lg': '12px',
  '-ds-radius-xl': '16px',
  '-ds-radius-xxl': '24px',
  '-ds-radius-round': '50px',
  '-ds-font-family-default': "'GT Walsheim Pro'",
  '-ds-font-title-large': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 500,
    fontSize: '48px',
    lineHeight: '1.1667',
    responsive: { 'min-768': { fontSize: '64px', lineHeight: '1.125' } },
  },
  '-ds-font-title-1': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 500,
    fontSize: '28px',
    lineHeight: '1.2857',
    responsive: { 'min-768': { fontSize: '40px', lineHeight: '1.2' } },
  },
  '-ds-font-title-2': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '1.3333',
    responsive: { 'min-768': { fontSize: '30px', lineHeight: '1.2667' } },
  },
  '-ds-font-title-3': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '1.4',
    responsive: { 'min-768': { fontSize: '24px', lineHeight: '1.3333' } },
  },
  '-ds-font-body-regular': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '1.5',
  },
  '-ds-font-body-emphasised': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '1.5',
  },
  '-ds-font-body-sm-regular': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '1.4286',
  },
  '-ds-font-body-sm-emphasised': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '1.4286',
  },
  '-ds-font-caption-regular': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '1.3333',
  },
  '-ds-font-caption-emphasised': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '1.3333',
  },
  '-ds-font-caption-sm': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 500,
    fontSize: '10px',
    lineHeight: '1.2',
  },
  '-ds-font-lead': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '1.5',
    responsive: { 'min-768': { fontSize: '20px', lineHeight: '1.4' } },
  },
  '-ds-font-body-light': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 300,
    fontSize: '16px',
    lineHeight: '1.5',
  },
  '-ds-font-body-sm-light': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 300,
    fontSize: '14px',
    lineHeight: '1.4286',
  },
  '-ds-font-caption-light': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 300,
    fontSize: '12px',
    lineHeight: '1.3333',
  },
  '-ds-font-section-title-emphasised': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '1.4',
    responsive: { 'min-768': { fontSize: '30px', lineHeight: '1.2667' } },
  },
  '-ds-font-section-title-regular': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '1.4',
    responsive: { 'min-768': { fontSize: '30px', lineHeight: '1.2667' } },
  },
  '-ds-font-section-title-light': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 300,
    fontSize: '20px',
    lineHeight: '1.4',
    responsive: { 'min-768': { fontSize: '30px', lineHeight: '1.2667' } },
  },
  '-ds-font-title-1-regular': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 400,
    fontSize: '28px',
    lineHeight: '1.2857',
    responsive: { 'min-768': { fontSize: '40px', lineHeight: '1.2' } },
  },
  '-ds-font-title-large-regular': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 400,
    fontSize: '48px',
    lineHeight: '1.1667',
    responsive: { 'min-768': { fontSize: '64px', lineHeight: '1.125' } },
  },
  '-ds-font-lead-light': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 300,
    fontSize: '16px',
    lineHeight: '1.5',
    responsive: { 'min-768': { fontSize: '20px', lineHeight: '1.4' } },
  },
  '-ds-font-title-2-regular': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '1.3333',
    responsive: { 'min-768': { fontSize: '30px', lineHeight: '1.2667' } },
  },
  '-ds-font-title-large-light': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 300,
    fontSize: '48px',
    lineHeight: '1.1667',
    responsive: { 'min-768': { fontSize: '64px', lineHeight: '1.125' } },
  },
  '-ds-font-title-3-regular': {
    fontFamily: 'GT Walsheim Pro',
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '1.4',
    responsive: { 'min-768': { fontSize: '24px', lineHeight: '1.3333' } },
  },
  '-ds-elevation-1':
    '0px 1px 2px 0px rgba(29, 29, 29, 0.08), 0px 4px 4px 0px rgba(29, 29, 29, 0.07), 0px 10px 6px 0px rgba(29, 29, 29, 0.04)',
  '-ds-elevation-2':
    '0px 1px 2px 0px rgba(29, 29, 29, 0.08), 0px 3px 3px 0px rgba(29, 29, 29, 0.07), 0px 6px 4px 0px rgba(29, 29, 29, 0.04)',
  '-ds-elevation-3':
    '0px 1px 1px 0px rgba(29, 29, 29, 0.08), 0px 2px 2px 0px rgba(29, 29, 29, 0.06), 0px 3px 3px 0px rgba(29, 29, 29, 0.04)',
} as const

// CSS-ready values: a var() reference with the resolved light value as the
// fallback, covering contexts that do not load application.css (Storybook,
// isolated mounts).
const designTokens = {
  '-ds-bg-default': 'var(--ds-bg-default, #ffffff)',
  '-ds-bg-container-brand': 'var(--ds-bg-container-brand, #0c6776)',
  '-ds-bg-container-default': 'var(--ds-bg-container-default, #ffffff)',
  '-ds-bg-container-secondary': 'var(--ds-bg-container-secondary, #f2f2f2)',
  '-ds-bg-container-tertiary': 'var(--ds-bg-container-tertiary, #e1e1e1)',
  '-ds-bg-container-inverse': 'var(--ds-bg-container-inverse, #212121)',
  '-ds-bg-container-strong': 'var(--ds-bg-container-strong, #fec077)',
  '-ds-bg-container-skeleton': 'var(--ds-bg-container-skeleton, #f2f2f2)',
  '-ds-border-default': 'var(--ds-border-default, #e1e1e1)',
  '-ds-border-strong': 'var(--ds-border-strong, #212121)',
  '-ds-border-inverse': 'var(--ds-border-inverse, #f8f8f8)',
  '-ds-border-disabled': 'var(--ds-border-disabled, #f8f8f8)',
  '-ds-border-focus': 'var(--ds-border-focus, #0c6776)',
  '-ds-divider-default': 'var(--ds-divider-default, #e1e1e1)',
  '-ds-bg-interactive-default': 'var(--ds-bg-interactive-default, #0c6776)',
  '-ds-bg-interactive-disabled': 'var(--ds-bg-interactive-disabled, #f8f8f8)',
  '-ds-bg-interactive-secondary': 'var(--ds-bg-interactive-secondary, #fec077)',
  '-ds-bg-interactive-pressed':
    'var(--ds-bg-interactive-pressed, rgba(0, 0, 0, 0.1))',
  '-ds-border-interactive-default':
    'var(--ds-border-interactive-default, #0c6776)',
  '-ds-border-interactive-light': 'var(--ds-border-interactive-light, #f2f2f2)',
  '-ds-bg-container-error': 'var(--ds-bg-container-error, #ab000d)',
  '-ds-bg-container-warning': 'var(--ds-bg-container-warning, #a12001)',
  '-ds-bg-container-success': 'var(--ds-bg-container-success, #0a4e45)',
  '-ds-bg-container-info': 'var(--ds-bg-container-info, #3e4a7c)',
  '-ds-bg-container-promo': 'var(--ds-bg-container-promo, #ffbc97)',
  '-ds-bg-container-error-subtle':
    'var(--ds-bg-container-error-subtle, #fcf5f6)',
  '-ds-bg-container-warning-subtle':
    'var(--ds-bg-container-warning-subtle, #fcf6f5)',
  '-ds-bg-container-success-subtle':
    'var(--ds-bg-container-success-subtle, #f5f8f8)',
  '-ds-bg-container-info-subtle': 'var(--ds-bg-container-info-subtle, #f7f8fa)',
  '-ds-bg-container-promo-subtle':
    'var(--ds-bg-container-promo-subtle, #fcf6f5)',
  '-ds-border-error': 'var(--ds-border-error, #ab000d)',
  '-ds-border-warning': 'var(--ds-border-warning, #a12001)',
  '-ds-border-success': 'var(--ds-border-success, #0a4e45)',
  '-ds-border-info': 'var(--ds-border-info, #3e4a7c)',
  '-ds-text-brand': 'var(--ds-text-brand, #0c6776)',
  '-ds-text-primary': 'var(--ds-text-primary, #212121)',
  '-ds-text-secondary': 'var(--ds-text-secondary, #424242)',
  '-ds-text-tertiary': 'var(--ds-text-tertiary, #767676)',
  '-ds-text-inverse': 'var(--ds-text-inverse, #f8f8f8)',
  '-ds-text-light': 'var(--ds-text-light, #f8f8f8)',
  '-ds-text-dark': 'var(--ds-text-dark, #212121)',
  '-ds-text-disabled': 'var(--ds-text-disabled, #979797)',
  '-ds-text-error': 'var(--ds-text-error, #ab000d)',
  '-ds-text-warning': 'var(--ds-text-warning, #a12001)',
  '-ds-text-success': 'var(--ds-text-success, #0a4e45)',
  '-ds-text-info': 'var(--ds-text-info, #3e4a7c)',
  '-ds-text-error-subtle': 'var(--ds-text-error-subtle, #fcf5f6)',
  '-ds-text-warning-subtle': 'var(--ds-text-warning-subtle, #fcf6f5)',
  '-ds-text-success-subtle': 'var(--ds-text-success-subtle, #f5f8f8)',
  '-ds-text-info-subtle': 'var(--ds-text-info-subtle, #f7f8fa)',
  '-ds-icon-brand': 'var(--ds-icon-brand, #0c6776)',
  '-ds-icon-primary': 'var(--ds-icon-primary, #212121)',
  '-ds-icon-secondary': 'var(--ds-icon-secondary, #424242)',
  '-ds-icon-tertiary': 'var(--ds-icon-tertiary, #767676)',
  '-ds-icon-inverse': 'var(--ds-icon-inverse, #f8f8f8)',
  '-ds-icon-light': 'var(--ds-icon-light, #f8f8f8)',
  '-ds-icon-dark': 'var(--ds-icon-dark, #212121)',
  '-ds-icon-wishlist': 'var(--ds-icon-wishlist, #fa9e9e)',
  '-ds-icon-disabled': 'var(--ds-icon-disabled, #979797)',
  '-ds-icon-error': 'var(--ds-icon-error, #ab000d)',
  '-ds-icon-warning': 'var(--ds-icon-warning, #a12001)',
  '-ds-icon-success': 'var(--ds-icon-success, #0a4e45)',
  '-ds-icon-info': 'var(--ds-icon-info, #3e4a7c)',
  '-ds-facebook': 'var(--ds-facebook, #1877f2)',
  '-ds-black-a3': 'var(--ds-black-a3, rgba(0, 0, 0, 0.03))',
  '-ds-black-a5': 'var(--ds-black-a5, rgba(0, 0, 0, 0.05))',
  '-ds-black-a7': 'var(--ds-black-a7, rgba(0, 0, 0, 0.07))',
  '-ds-black-a10': 'var(--ds-black-a10, rgba(0, 0, 0, 0.1))',
  '-ds-black-a15': 'var(--ds-black-a15, rgba(0, 0, 0, 0.15))',
  '-ds-black-a20': 'var(--ds-black-a20, rgba(0, 0, 0, 0.2))',
  '-ds-black-a25': 'var(--ds-black-a25, rgba(0, 0, 0, 0.25))',
  '-ds-black-a30': 'var(--ds-black-a30, rgba(0, 0, 0, 0.3))',
  '-ds-black-a40': 'var(--ds-black-a40, rgba(0, 0, 0, 0.4))',
  '-ds-black-a50': 'var(--ds-black-a50, rgba(0, 0, 0, 0.5))',
  '-ds-black-a60': 'var(--ds-black-a60, rgba(0, 0, 0, 0.6))',
  '-ds-black-a80': 'var(--ds-black-a80, rgba(0, 0, 0, 0.8))',
  '-ds-white-a3': 'var(--ds-white-a3, rgba(255, 255, 255, 0.03))',
  '-ds-white-a5': 'var(--ds-white-a5, rgba(255, 255, 255, 0.05))',
  '-ds-white-a7': 'var(--ds-white-a7, rgba(255, 255, 255, 0.07))',
  '-ds-white-a10': 'var(--ds-white-a10, rgba(255, 255, 255, 0.1))',
  '-ds-white-a15': 'var(--ds-white-a15, rgba(255, 255, 255, 0.15))',
  '-ds-white-a20': 'var(--ds-white-a20, rgba(255, 255, 255, 0.2))',
  '-ds-white-a25': 'var(--ds-white-a25, rgba(255, 255, 255, 0.25))',
  '-ds-white-a30': 'var(--ds-white-a30, rgba(255, 255, 255, 0.3))',
  '-ds-white-a40': 'var(--ds-white-a40, rgba(255, 255, 255, 0.4))',
  '-ds-white-a50': 'var(--ds-white-a50, rgba(255, 255, 255, 0.5))',
  '-ds-white-a60': 'var(--ds-white-a60, rgba(255, 255, 255, 0.6))',
  '-ds-white-a80': 'var(--ds-white-a80, rgba(255, 255, 255, 0.8))',
  '-ds-space-01': 'var(--ds-space-01, 4px)',
  '-ds-space-02': 'var(--ds-space-02, 8px)',
  '-ds-space-03': 'var(--ds-space-03, 12px)',
  '-ds-space-04': 'var(--ds-space-04, 16px)',
  '-ds-space-05': 'var(--ds-space-05, 24px)',
  '-ds-space-06': 'var(--ds-space-06, 32px)',
  '-ds-space-07': 'var(--ds-space-07, 40px)',
  '-ds-space-08': 'var(--ds-space-08, 56px)',
  '-ds-space-09': 'var(--ds-space-09, 64px)',
  '-ds-space-10': 'var(--ds-space-10, 80px)',
  '-ds-radius-none': 'var(--ds-radius-none, 0px)',
  '-ds-radius-xs': 'var(--ds-radius-xs, 2px)',
  '-ds-radius-sm': 'var(--ds-radius-sm, 4px)',
  '-ds-radius-md': 'var(--ds-radius-md, 8px)',
  '-ds-radius-lg': 'var(--ds-radius-lg, 12px)',
  '-ds-radius-xl': 'var(--ds-radius-xl, 16px)',
  '-ds-radius-xxl': 'var(--ds-radius-xxl, 24px)',
  '-ds-radius-round': 'var(--ds-radius-round, 50px)',
  '-ds-font-family-default': "var(--ds-font-family-default, 'GT Walsheim Pro')",
  '-ds-font-title-large': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-title-large-weight, 500)',
    fontSize: 'var(--ds-font-title-large-size, 48px)',
    lineHeight: 'var(--ds-font-title-large-line-height, 1.1667)',
  },
  '-ds-font-title-1': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-title-1-weight, 500)',
    fontSize: 'var(--ds-font-title-1-size, 28px)',
    lineHeight: 'var(--ds-font-title-1-line-height, 1.2857)',
  },
  '-ds-font-title-2': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-title-2-weight, 500)',
    fontSize: 'var(--ds-font-title-2-size, 24px)',
    lineHeight: 'var(--ds-font-title-2-line-height, 1.3333)',
  },
  '-ds-font-title-3': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-title-3-weight, 500)',
    fontSize: 'var(--ds-font-title-3-size, 20px)',
    lineHeight: 'var(--ds-font-title-3-line-height, 1.4)',
  },
  '-ds-font-body-regular': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-body-regular-weight, 400)',
    fontSize: 'var(--ds-font-body-regular-size, 16px)',
    lineHeight: 'var(--ds-font-body-regular-line-height, 1.5)',
  },
  '-ds-font-body-emphasised': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-body-emphasised-weight, 500)',
    fontSize: 'var(--ds-font-body-emphasised-size, 16px)',
    lineHeight: 'var(--ds-font-body-emphasised-line-height, 1.5)',
  },
  '-ds-font-body-sm-regular': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-body-sm-regular-weight, 400)',
    fontSize: 'var(--ds-font-body-sm-regular-size, 14px)',
    lineHeight: 'var(--ds-font-body-sm-regular-line-height, 1.4286)',
  },
  '-ds-font-body-sm-emphasised': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-body-sm-emphasised-weight, 500)',
    fontSize: 'var(--ds-font-body-sm-emphasised-size, 14px)',
    lineHeight: 'var(--ds-font-body-sm-emphasised-line-height, 1.4286)',
  },
  '-ds-font-caption-regular': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-caption-regular-weight, 400)',
    fontSize: 'var(--ds-font-caption-regular-size, 12px)',
    lineHeight: 'var(--ds-font-caption-regular-line-height, 1.3333)',
  },
  '-ds-font-caption-emphasised': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-caption-emphasised-weight, 500)',
    fontSize: 'var(--ds-font-caption-emphasised-size, 12px)',
    lineHeight: 'var(--ds-font-caption-emphasised-line-height, 1.3333)',
  },
  '-ds-font-caption-sm': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-caption-sm-weight, 500)',
    fontSize: 'var(--ds-font-caption-sm-size, 10px)',
    lineHeight: 'var(--ds-font-caption-sm-line-height, 1.2)',
  },
  '-ds-font-lead': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-lead-weight, 400)',
    fontSize: 'var(--ds-font-lead-size, 16px)',
    lineHeight: 'var(--ds-font-lead-line-height, 1.5)',
  },
  '-ds-font-body-light': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-body-light-weight, 300)',
    fontSize: 'var(--ds-font-body-light-size, 16px)',
    lineHeight: 'var(--ds-font-body-light-line-height, 1.5)',
  },
  '-ds-font-body-sm-light': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-body-sm-light-weight, 300)',
    fontSize: 'var(--ds-font-body-sm-light-size, 14px)',
    lineHeight: 'var(--ds-font-body-sm-light-line-height, 1.4286)',
  },
  '-ds-font-caption-light': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-caption-light-weight, 300)',
    fontSize: 'var(--ds-font-caption-light-size, 12px)',
    lineHeight: 'var(--ds-font-caption-light-line-height, 1.3333)',
  },
  '-ds-font-section-title-emphasised': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-section-title-emphasised-weight, 500)',
    fontSize: 'var(--ds-font-section-title-emphasised-size, 20px)',
    lineHeight: 'var(--ds-font-section-title-emphasised-line-height, 1.4)',
  },
  '-ds-font-section-title-regular': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-section-title-regular-weight, 400)',
    fontSize: 'var(--ds-font-section-title-regular-size, 20px)',
    lineHeight: 'var(--ds-font-section-title-regular-line-height, 1.4)',
  },
  '-ds-font-section-title-light': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-section-title-light-weight, 300)',
    fontSize: 'var(--ds-font-section-title-light-size, 20px)',
    lineHeight: 'var(--ds-font-section-title-light-line-height, 1.4)',
  },
  '-ds-font-title-1-regular': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-title-1-regular-weight, 400)',
    fontSize: 'var(--ds-font-title-1-regular-size, 28px)',
    lineHeight: 'var(--ds-font-title-1-regular-line-height, 1.2857)',
  },
  '-ds-font-title-large-regular': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-title-large-regular-weight, 400)',
    fontSize: 'var(--ds-font-title-large-regular-size, 48px)',
    lineHeight: 'var(--ds-font-title-large-regular-line-height, 1.1667)',
  },
  '-ds-font-lead-light': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-lead-light-weight, 300)',
    fontSize: 'var(--ds-font-lead-light-size, 16px)',
    lineHeight: 'var(--ds-font-lead-light-line-height, 1.5)',
  },
  '-ds-font-title-2-regular': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-title-2-regular-weight, 400)',
    fontSize: 'var(--ds-font-title-2-regular-size, 24px)',
    lineHeight: 'var(--ds-font-title-2-regular-line-height, 1.3333)',
  },
  '-ds-font-title-large-light': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-title-large-light-weight, 300)',
    fontSize: 'var(--ds-font-title-large-light-size, 48px)',
    lineHeight: 'var(--ds-font-title-large-light-line-height, 1.1667)',
  },
  '-ds-font-title-3-regular': {
    fontFamily: "var(--ds-font-family-default, 'GT Walsheim Pro')",
    fontWeight: 'var(--ds-font-title-3-regular-weight, 400)',
    fontSize: 'var(--ds-font-title-3-regular-size, 20px)',
    lineHeight: 'var(--ds-font-title-3-regular-line-height, 1.4)',
  },
  '-ds-elevation-1':
    'var(--ds-elevation-1, 0px 1px 2px 0px rgba(29, 29, 29, 0.08), 0px 4px 4px 0px rgba(29, 29, 29, 0.07), 0px 10px 6px 0px rgba(29, 29, 29, 0.04))',
  '-ds-elevation-2':
    'var(--ds-elevation-2, 0px 1px 2px 0px rgba(29, 29, 29, 0.08), 0px 3px 3px 0px rgba(29, 29, 29, 0.07), 0px 6px 4px 0px rgba(29, 29, 29, 0.04))',
  '-ds-elevation-3':
    'var(--ds-elevation-3, 0px 1px 1px 0px rgba(29, 29, 29, 0.08), 0px 2px 2px 0px rgba(29, 29, 29, 0.06), 0px 3px 3px 0px rgba(29, 29, 29, 0.04))',
} as const

export default designTokens
